import {createAction, ActionCreator} from '@packages/utilities/create-action';
import type {CodeComponentsSafeModeReason} from '@packages/domains/code-libraries/data-types';

export const MULTIPLAYER_SITE_CODE_COMPONENTS_SAFE_MODE_REASON_UPDATED_REMOTELY =
  'MULTIPLAYER_SITE_CODE_COMPONENTS_SAFE_MODE_REASON_UPDATED_REMOTELY';

export const multiplayerSiteCodeComponentsSafeModeReasonUpdatedRemotely: ActionCreator<
  typeof MULTIPLAYER_SITE_CODE_COMPONENTS_SAFE_MODE_REASON_UPDATED_REMOTELY,
  {
    codeComponentsSafeModeReason: CodeComponentsSafeModeReason | null;
  }
> = createAction(
  MULTIPLAYER_SITE_CODE_COMPONENTS_SAFE_MODE_REASON_UPDATED_REMOTELY
);
